import React, { useState, useEffect, useRef } from 'react'
//import { NavLink } from 'react-router-dom';
//import UseLang from '../../../hook/UseLang';
import PhotoButton from '../photos/PhotoButton';
import Photos from '../photos/Photos'; 
//import StandButton from '../stand/StandButton';

const Apps = props => {
  const [app, setApp] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setApp(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [ref]);

  const handleApp = () => {
    setApp(!app);
  }

  const handleButtonClick = (event) => {
    event.stopPropagation();
    handleApp();
  }
 

  return (
    <>
    <li className="select_apps" ref={ref}>
      {!app ?<button className="button_apps" onClick={handleButtonClick}>
        <i className="icon-grid-circle"></i>
      </button> : <button className="button_apps" onClick={handleButtonClick}>
        <i className="icon-xmark"></i>
      </button>}
      {app ? 
        <div className="event_apps">
          <div>
            {/* <a href="https://rir.la/lacnic39" target='_blank' rel="noreferrer"><i className="icon-video-call"></i> Zoom</a>
            <NavLink to="/streaming"><i className="icon-you-tube-border"></i> 
                <UseLang es>Transmisión en vivo</UseLang> 
                <UseLang en>Live streaming</UseLang> 
                <UseLang pt_br>Transmissão ao vivo</UseLang> 
            </NavLink>
            <a href="https://discord.gg/YSf6UUx3yY" target='_blank' rel="noreferrer"><i className="icon-discord-1"></i> Discord</a>
            <NavLink to="/es/registro"><i className="icon-registration"></i> 
                <UseLang es>Registro</UseLang>
                <UseLang en>Registration</UseLang>
                <UseLang pt_br>Inscrição</UseLang>
            </NavLink>   */}
            <PhotoButton  />  
            {/* <StandButton  /> */}
          </div>
        </div>
        : undefined
      }
    </li>
    <Photos />
    </>
  );
}

export default Apps;
